import { Avatar, Card, Chip, Stack, Typography } from "@mui/material";
import { Customer } from "../pages/Projects";
import KebabMenu from "./KebabMenu";
import { MenuItem } from "@mui/material";

interface Props {
  customer: Customer;
  deleteCustomer: (id: string) => void;
  onEditCustomerHandler: (customer: Customer) => void;
}

const stringToColor = (value: string) => {
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = value.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = hash % 360;
  return `hsl(${hue}, 60%, 45%)`;
};

const CustomerCard = (props: Props) => {
  const { customer, deleteCustomer, onEditCustomerHandler } = props;
  const { name, slug, id } = customer;

  return (
    <Card sx={{ borderRadius: 3, p: 2 }}>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Avatar sx={{ bgcolor: stringToColor(name || 'kunde'), fontWeight: 700 }}>
          {(name || '?').trim().charAt(0).toUpperCase()}
        </Avatar>
        <Stack spacing={0.5} sx={{ flexGrow: 1, minWidth: 0 }}>
          <Typography variant="subtitle1" fontWeight={700} noWrap title={name}>{name}</Typography>
          <Chip size="small" label={slug} sx={{ alignSelf: 'flex-start', bgcolor: '#EEF2FF', color: '#4F46E5' }} />
        </Stack>
        <KebabMenu>
          <MenuItem onClick={() => onEditCustomerHandler(customer)}>Rediger</MenuItem>
          <MenuItem onClick={() => deleteCustomer(id ?? '')}>Slet</MenuItem>
        </KebabMenu>
      </Stack>
    </Card>
  );
};

export default CustomerCard;
